import { getClient } from '@updater-core/lib/contentful';
import { IS_PRODUCTION, IS_DEMO } from '@updater-core/lib/environment';

const env = IS_PRODUCTION || IS_DEMO ? 'production' : 'preview';
const client = getClient(env);
export { client };
